export const LOXO_FLOATING_BASE = 'loxo-floating-base';
export const LOXO_FLOATING_PRIORITY = 'loxo-floating-priority';
